
import { SymptomCheckResultsPreVisitComponent } from '../../components/symptom-check/symptom-check-results-pre-visit.component';
import { SymptomCheckResultsPayComponent } from '../../components/symptom-check/symptom-check-results-pay.component';
import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'symptom-check-results',
	templateUrl: './symptom-check-results.component.html',
	imports: [ CommonModule, SymptomCheckResultsPreVisitComponent, SymptomCheckResultsPayComponent, FormsModule ]
})
export class SymptomCheckResultsComponent implements OnInit {
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	
	@Input() interview: any;
	@Input() config: any;
	@Input() problemDescription: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
	}
	
}